var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.platform
    ? _c(
        "div",
        {
          staticClass: "page-platform",
          style: {
            "background-image":
              "url(" +
              _vm.platform.background[_vm.isWebpSupported ? "webp" : "jpg"] +
              ")"
          }
        },
        [
          _c(
            "v-container",
            [
              _vm.platform
                ? _c("platform-item-description", {
                    attrs: { "platform-item": _vm.platform }
                  })
                : _vm._e(),
              _c("div", { staticClass: "section-listGame__header" }, [
                _c("div", { staticClass: "title" }, [
                  _c(
                    "picture",
                    [
                      _vm._l(_vm.platform.icon.sourcesTypes, function(
                        sourceType,
                        index
                      ) {
                        return _c("source", {
                          key: index,
                          attrs: {
                            srcset: _vm.platform.icon[sourceType],
                            type: "image/" + sourceType
                          }
                        })
                      }),
                      _c("img", {
                        attrs: {
                          src: _vm.platform.icon.jpg || _vm.defaultPlatformIcon,
                          alt: _vm.platform.title
                        }
                      })
                    ],
                    2
                  ),
                  _c("div", { staticClass: "title__text" }, [
                    _c("h2", {
                      domProps: { textContent: _vm._s(_vm.platform.title) }
                    })
                  ])
                ]),
                !_vm.showAllGamesMode
                  ? _c(
                      "div",
                      { staticClass: "link" },
                      [
                        _c("router-link", { attrs: { to: _vm.allGamesUrl } }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("front.game.button.see_all")) +
                                " " +
                                _vm._s(_vm.totalGamesCount)
                            )
                          ]),
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "7",
                                height: "12",
                                viewBox: "0 0 7 12",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }
                            },
                            [
                              _c("path", {
                                attrs: { d: "M1 11L6 6L1 1", stroke: "#926D20" }
                              })
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._l(_vm.cycleComponents, function(component, index) {
                return _c(component, {
                  key: index,
                  tag: "component",
                  attrs: { items: _vm.getComponentItems(index) }
                })
              }),
              !_vm.showAllGamesMode && _vm.hasMoreGames
                ? _c(
                    "div",
                    {
                      staticClass: "btn-loadCatalog",
                      on: {
                        click: function($event) {
                          return _vm.showMoreGames()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("front.game.button.load_more")))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }